let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kLYDM")).then(() => parcelRequire('14EEk'));